var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:_vm.flexWrap ? 'flex-wrap' : '',attrs:{"id":"tags"}},_vm._l((_vm.tagsList),function(tag,index){return _c('li',{key:index,on:{"click":function($event){return _vm.searchByTag($event, tag)}}},[_vm._v(" "+_vm._s(tag)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }